import * as React from "react";
const SVGComponent = ({ props }: { props?: { fill?: string } }) => {
  const color = props?.fill ?? 'white'
  return (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.81815 11.7475C1.81815 9.694 1.81815 8.66724 2.21779 7.88289C2.56932 7.19297 3.13025 6.63204 3.82018 6.2805C4.60452 5.88086 5.63129 5.88086 7.68481 5.88086H12.2478C14.3013 5.88086 15.3281 5.88086 16.1124 6.2805C16.8023 6.63204 17.3633 7.19297 17.7148 7.88289C18.1144 8.66724 18.1144 9.694 18.1144 11.7475V16.3105C18.1144 18.364 18.1144 19.3908 17.7148 20.1751C17.3633 20.865 16.8023 21.426 16.1124 21.7775C15.3281 22.1772 14.3013 22.1772 12.2478 22.1772H7.68481C5.63129 22.1772 4.60452 22.1772 3.82018 21.7775C3.13025 21.426 2.56932 20.865 2.21779 20.1751C1.81815 19.3908 1.81815 18.364 1.81815 16.3105V11.7475Z"
      stroke={color}
      strokeWidth={1.62963}
    />
    <path
      d="M17.3667 16.6141L15.2941 15.4838C14.6026 15.1066 14.2568 14.918 13.8898 14.8345C13.5648 14.7605 13.2288 14.7469 12.8989 14.7945C12.5263 14.8483 12.166 15.0086 11.4454 15.3293C8.21963 16.7649 6.71611 17.4324 3.29519 18.9265C3.00533 19.0531 2.81664 19.3399 2.81651 19.6562C2.81615 20.5355 3.52886 21.2485 4.40815 21.2485H14.4041C15.2125 21.2485 15.6167 21.2485 15.9491 21.1631C16.9083 20.9167 17.6574 20.1678 17.904 19.2086C17.9894 18.8762 17.9895 18.472 17.9897 17.6637V17.6636C17.9897 17.497 17.9897 17.4137 17.9764 17.337C17.9385 17.1179 17.8213 16.9204 17.6471 16.7822C17.5862 16.7338 17.513 16.6939 17.3667 16.6141Z"
      fill={color}
      stroke={color}
      strokeWidth={1.8107}
    />
    <circle cx={7.24999} cy={11.3168} r={2.26337} fill={color} />
    <path
      d="M5.88562 6.09868C5.88562 5.53263 5.88562 5.24961 5.91681 5.01199C6.13296 3.36557 7.42859 2.06994 9.07501 1.85379C9.31263 1.8226 9.59565 1.8226 10.1617 1.8226L16.3153 1.8226C18.3688 1.8226 19.3955 1.8226 20.1799 2.22224C20.8698 2.57378 21.4307 3.13471 21.7823 3.82463C22.1819 4.60898 22.1819 5.63574 22.1819 7.68927L22.1819 14.1678C22.1819 14.4319 22.1819 14.5639 22.1751 14.6755C22.0623 16.5247 20.5877 17.9993 18.7385 18.1121C18.627 18.1189 18.4949 18.1189 18.2308 18.1189"
      stroke={color}
      strokeWidth={1.62963}
    />
  </svg>
  )
};
export default SVGComponent;